import {
  LabelsViewColumns,
  labelsSearchSchema,
  mapLabelsViewQuery,
} from "./LabelsView.default";
import ManagedGridView from "../../controls/ManagedGridView";
import { SearchQuery } from "../../code/search-query/search-query";
import { getLabels } from "../../repository/data.repository";
import { createGridRequest } from "../../hooks/useGridRequest";
import { useSelector } from "../../store/store";
import { authorizeSelectors } from "../../store/authorize";

export interface LabelsViewProps {
  readonly trigger?: string;
  readonly onAction?: (key: string, record: any) => void;
  readonly onSearch?: (searchQuery: SearchQuery) => void;
}

function LabelsView(props: LabelsViewProps) {
  const permissions = useSelector(authorizeSelectors.permissions);

  return (
    <ManagedGridView
      trigger={props.trigger}
      columns={LabelsViewColumns}
      schema={labelsSearchSchema}
      mapQuery={mapLabelsViewQuery}
      onSearch={props.onSearch}
      request={createGridRequest(getLabels, { retry: true })}
      pageSize={100}
      actions={[
        {
          key: "update",
          label: "Edit",
          disabled: !permissions.can("Labels", "edit"),
          handler: (key, record) => props.onAction?.(key, record),
        },
        {
          key: "delete",
          label: "Delete",
          danger: true,
          disabled: !permissions.can("Labels", "delete"),
          handler: (key, record) => props.onAction?.(key, record),
        },
      ]}
    />
  );
}

export default LabelsView;
